module.exports = __webpack_public_path__ + "img/firestone-sommer.c8174690.png";